import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UsersService } from '../../services/users/users.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from '../../services/session/session.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TemplatesService } from '../../services/templates/templates.service';
import { DeleteUserModalComponent } from '../../components/modals/delete-user-modal/delete-user-modal.component';
import { EditUserModalComponent } from '../../components/modals/edit-user-modal/edit-user-modal.component';
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  public users: any = [];
  public showMenu: any = false;
  public showSideMenu: any = true;
  isAdmin: boolean;
  changeDetect: ChangeDetectionStrategy.OnPush;
  public pagination = {
    currentPage: 1,
    pageSize: 5,
    maxSize: 5,
    size: 0
  };

  constructor(
    private UsersService: UsersService,
    private router: Router,
    private route: ActivatedRoute,
    private SessionService: SessionService,
    private TemplatesService: TemplatesService,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {
    this.isAdmin = this.SessionService.isAdmin();
  }

  showMenuFn() {
    this.showMenu = !this.showMenu;
  }
  showSideMenuFn() {
    this.showSideMenu = !this.showSideMenu;
  }
  Logout() {
    this.SessionService.logout();
    this.router.navigate(['/']);
  }

  editUser(user) {
    const modalRef = this.modalService.open(EditUserModalComponent);
    modalRef.componentInstance.user = user;
    modalRef.result
      .then(() => {
        this.loadUsers();
      })
      .catch(() => {
        this.loadUsers();
      });
  }

  addUser() {
    const modalRef = this.modalService.open(EditUserModalComponent);
    modalRef.result
      .then(() => {
        this.loadUsers();
      })
      .catch(() => {
        this.loadUsers();
      });
  }

  deleteUser(user) {
    const modalRef = this.modalService.open(DeleteUserModalComponent);
    modalRef.componentInstance.user = user;
    modalRef.result
      .then(() => {
        this.loadUsers();
      })
      .catch(() => {
        this.loadUsers();
      });
  }

  OnPageChange(newPageNumber) {
    this.pagination.currentPage = newPageNumber;
    this.loadUsers();
  }

  loadUsers() {
    this.UsersService.getAllUsers({
      limit: this.pagination.pageSize,
      offset: (this.pagination.currentPage-1)*this.pagination.pageSize
    }).then((res) => {
      console.log(res['data']);
      this.users = res['data'];
      this.pagination.size = parseInt(res['pagination'].count);
    });
  }

  ngOnInit(): void {
    this.loadUsers();
  }
}
